module.exports = __webpack_public_path__ + "static/img/Bachelor_010856.b66b8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010856.jpg
// module id = 264
// module chunks = 0